import { Splide } from "@splidejs/splide";

document.addEventListener( 'DOMContentLoaded', function() {
  var imageSliderDivs = document.querySelectorAll('.image-slider');

  if (imageSliderDivs.length > 0) {
    for(var i=0; i<imageSliderDivs.length; i++){
      const imageSlider = new Splide(imageSliderDivs[i] as HTMLElement, {
        type: "fade",
        arrows: true,
        speed: 150,
        rewind: false,
        perMove: 1,
        waitForTransition: true,
        pagination: true,
        flickPower: 100,
        flickMaxPages: 1,
        updateOnMove: true,
        padding: { bottom: 50 },
        breakpoints: {
          768: {
            //pagination: true,
          },
        },
      });

      imageSlider.mount();
    }
  }
});